export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  static async fromResponse(res: Response): Promise<ApiError> {
    let code = 'unknown';
    let message = res.statusText || 'Request failed';
    let details: unknown;
    try {
      const body = (await res.json()) as { code?: string; message?: string; details?: unknown };
      if (body?.code) code = body.code;
      if (body?.message) message = body.message;
      details = body?.details;
    } catch {
      /* noop: non-json error body */
    }
    return new ApiError(res.status, code, message, details);
  }
}

export function isUnauthorized(err: unknown): boolean {
  return err instanceof ApiError && err.status === 401;
}
